import { useState, useEffect, Fragment } from 'react';
import {
    CloudArrowUpIcon,
    PlusCircleIcon,
    DocumentMagnifyingGlassIcon,
    PencilSquareIcon,
} from '@heroicons/react/20/solid';
import { Dialog, Transition } from '@headlessui/react'

//services
import BuildingService from '../../services/building.service';
import { toast } from 'react-toastify';

export default function AdminBuildingsView() {
    const [modalOpen, setModalOpen] = useState(false);
    const [buildings, setBuildings] = useState([]);
    const [contracts, setContracts] = useState([]);
    const [activeFilter, setActiveFilter] = useState('all');

    //individual building
    const [image, setImage] = useState(null);
    const [imageLink, setImageLink] = useState("");
    const [name, setName] = useState("");
    const [type, setType] = useState("");
    const [proxyDutch, setProxyDutch] = useState(0);
    const [proxyFrench, setProxyFrench] = useState(0);
    const [onlineDutch, setOnlineDutch] = useState(0);
    const [onlineFrench, setOnlineFrench] = useState(0);
    const [metadataFields, setMetadataFields] = useState([]);

    //edit metadata
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [editBuildingId, setEditBuildingId] = useState(null);
    const [editBuildingType, setEditBuildingType] = useState("");
    const [editMetadataFields, setEditMetadataFields] = useState([]);

    const [upload, setUpload] = useState(false);

    useEffect(() => {
        document.title = "Assemblo - Admin - Gebouwen"
        BuildingService.getBuildings()
            .then(response => {
                setBuildings(response.data);
                console.log(response.data)
            }
            )
            .catch(err => {
                console.log(err);
            }
            );

        BuildingService.getContracts()
            .then(response => {
                setContracts(response.data);
            })
            .catch(err => {
                console.log(err);
            });

    }, []);

    function uploadFile(file) {
        if (file) {
            const formData = new FormData();
            formData.append("file", file);
            BuildingService.uploadFile(formData)
                .then(response => {
                        setImageLink(response.data);
                        setUpload(true);
                })
                .catch(err => {
                    console.log(err);
                });
        }
    }

    function createBuilding() {
        if (!type || !name || !image ) {
            toast.error("Please fill in all fields");
        } else {
            if (type == "VME" && (proxyDutch <= 0 || proxyFrench <=0 || onlineDutch <= 0 || onlineFrench <= 0)) {
                toast.error("Please fill in all fields");
            } else if (type == "BV" && (proxyDutch <= 0 || proxyFrench <=0)) {
                toast.error("Please fill in all fields");
            } else if (type == "BAV" && proxyDutch <= 0) {
                toast.error("Please fill in all fields");
            } else if (type == "BAV" && (!metadataFields.find(f => f.key === "companyName")?.value || !metadataFields.find(f => f.key === "companyNumber")?.value)) {
                toast.error("companyName en companyNumber zijn verplicht voor BAV");
            } else {
                uploadFile(image);
            }
        } 
    }

    useEffect(() => {
        if (upload) {
            BuildingService.createBuilding({
                image: imageLink,
                name: name,
                type: type,
                proxyDutch: proxyDutch,
                proxyFrench: proxyFrench,
                onlineDutch: onlineDutch,
                onlineFrench: onlineFrench,
                building_metadata: metadataFields.length > 0 ? JSON.stringify(Object.fromEntries(metadataFields.filter(f => f.key).map(f => [f.key, f.value]))) : null,
            })
                .then(response => {
                    setBuildings([...buildings, response.data]);
                    closeModal();
                }
                )
                .catch(err => {
                    console.log(err);
                }
                );
        }
    }, [upload]);

    function openDocument(id) {
        window.open(process.env.REACT_APP_DOCUSIGN_URI + 'documents/templates/' + id, "_blank");
    }

    function openEditModal(building) {
        let fields = building.building_metadata
            ? Object.entries(JSON.parse(building.building_metadata)).map(([key, value]) => ({ key, value }))
            : [];
        if (building.type === "BAV") {
            if (!fields.some(f => f.key === "companyName")) fields.unshift({ key: "companyName", value: "" });
            if (!fields.some(f => f.key === "companyNumber")) {
                const idx = fields.findIndex(f => f.key === "companyName");
                fields.splice(idx + 1, 0, { key: "companyNumber", value: "" });
            }
        }
        setEditBuildingId(building.id);
        setEditBuildingType(building.type);
        setEditMetadataFields(fields);
        setEditModalOpen(true);
    }

    function saveMetadata() {
        if (editBuildingType === "BAV" && (!editMetadataFields.find(f => f.key === "companyName")?.value || !editMetadataFields.find(f => f.key === "companyNumber")?.value)) {
            toast.error("companyName en companyNumber zijn verplicht voor BAV");
            return;
        }
        const metadata = editMetadataFields.length > 0
            ? JSON.stringify(Object.fromEntries(editMetadataFields.filter(f => f.key).map(f => [f.key, f.value])))
            : null;
        BuildingService.updateBuilding(editBuildingId, { building_metadata: metadata })
            .then(response => {
                setBuildings(buildings.map(b => b.id === editBuildingId ? response.data : b));
                setEditModalOpen(false);
            })
            .catch(err => {
                console.log(err);
                toast.error("Kon metadata niet opslaan.");
            });
    }

    function closeModal() {
        setModalOpen(false);
        setImage(null);
        setName("");
        setType("");
        setProxyDutch(null);
        setProxyFrench(null);
        setOnlineDutch(null);
        setOnlineFrench(null);
        setMetadataFields([]);
        setUpload(false);
    }

    const filteredBuildings = buildings.filter(building => {
        if (activeFilter === 'all') return true;
        return building.type === activeFilter;
    });

    const tabs = [
        { id: 'all', name: 'Alle gebouwen' },
        { id: 'BV', name: 'BV' },
        { id: 'BAV', name: 'BAV' },
        { id: 'VME', name: 'VME' },
        { id: 'IV', name: 'Infovergaderingen' }
    ];

    return (
        <main className="flex-1">
            <div className="py-6">
                <div className="mx-auto px-4 sm:px-6 lg:px-8 sm:flex sm:items-center sm:justify-between">
                    <h1 className="text-2xl font-semibold text-gray-900">Gebouwen</h1>
                    <div className="mt-3 sm:mt-0 sm:ml-4">
                        <button
                            type="button"
                            onClick={(e) => setModalOpen(true)}
                            className="inline-flex items-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                        >
                            <PlusCircleIcon className="-ml-1 mr-2 h-5 w-5" aria-hidden="true" />
                            Nieuw gebouw toevoegen
                        </button>
                    </div>
                </div>
                <div className="mx-auto px-4 sm:px-6 md:px-8">
                    <p>Hieronder een lijst van alle Assemblo-gebouwen.</p>
                    <br />
                    <p className="text-gray-400 text-sm">Bij het aanmaken van een AV wordt gevraagd welke DocuSign contracten je wilt koppelen. Contacteer Louis Mylle om je contract klaar te zetten in Docusign en te koppelen.</p>

                    {/* Tab Filter */}
                    <div className="mt-8 bg-white px-4 py-5 sm:px-6 rounded-lg shadow">
                        <div className="sm:hidden">
                            <select
                                value={activeFilter}
                                onChange={(e) => setActiveFilter(e.target.value)}
                                className="block w-full rounded-md border-gray-300 focus:border-indigo-500 focus:ring-indigo-500"
                            >
                                {tabs.map((tab) => (
                                    <option key={tab.id} value={tab.id}>
                                        {tab.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="hidden sm:block">
                            <nav className="flex space-x-8" aria-label="Tabs">
                                {tabs.map((tab) => (
                                    <button
                                        key={tab.id}
                                        onClick={() => setActiveFilter(tab.id)}
                                        className={`whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm ${
                                            activeFilter === tab.id
                                                ? 'border-indigo-500 text-indigo-600'
                                                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                                        }`}
                                    >
                                        {tab.name}
                                    </button>
                                ))}
                            </nav>
                        </div>
                    </div>

                    {/* content */}
                    <div className="mt-10">
                        <ul role="list" className="grid grid-cols-1 gap-6 sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-5">
                            {filteredBuildings.map((building) => (
                                <li
                                    key={building.id}
                                    className="col-span-1 flex flex-col divide-y divide-gray-200 rounded-lg bg-white text-center shadow h-full"
                                >
                                    <div className="flex flex-1 flex-col h-full">
                                        <div className="flex-grow flex items-center justify-center overflow-hidden rounded-t-lg bg-gray-200">
                                            <img className="w-full h-auto object-cover object-center" src={process.env.REACT_APP_API_URI + "file/download/" + building.image} alt="" />
                                        </div>
                                        {building.type == "VME" ? (
                                                <div className="-mt-px flex divide-x divide-gray-200 border-b border-t">
                                                    <div className="flex w-0 flex-1">
                                                        <a
                                                            onClick={() => openDocument(contracts.find(contract => contract.id == building.onlineDutch_id).template_id)}
                                                            className="relative -mr-px inline-flex w-0 flex-1 items-center justify-center rounded-bl-lg border border-transparent py-4 text-sm font-medium text-gray-700 hover:text-gray-500"
                                                        >
                                                            <DocumentMagnifyingGlassIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                                            <span className="ml-3">Online (NL)</span>
                                                        </a>
                                                    </div>
                                                    <div className="-ml-px flex w-0 flex-1">
                                                        <a
                                                            onClick={() => openDocument(contracts.find(contract => contract.id == building.onlineFrench_id).template_id)}
                                                            className="relative inline-flex w-0 flex-1 items-center justify-center rounded-br-lg border border-transparent py-4 text-sm font-medium text-gray-700 hover:text-gray-500"
                                                        >
                                                            <DocumentMagnifyingGlassIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                                            <span className="ml-3">Online (FR)</span>
                                                        </a>
                                                    </div>
                                                </div>) : null}
                                                {building.type == "VME" || building.type == "BV" ? (
                                        <div className="">
                                            <div className="-mt-px flex divide-x divide-gray-200 border-t">
                                                <div className="flex w-0 flex-1">
                                                    <a
                                                        onClick={() => openDocument(contracts.find(contract => contract.id == building.proxyDutch_id).template_id)}
                                                        className="relative -mr-px inline-flex w-0 flex-1 items-center justify-center rounded-bl-lg border border-transparent py-4 text-sm font-medium text-gray-700 hover:text-gray-500"
                                                    >
                                                        <DocumentMagnifyingGlassIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                                        <span className="ml-3">Volmacht (NL)</span>
                                                    </a>
                                                </div>
                                                <div className="-ml-px flex w-0 flex-1">
                                                    <a
                                                        onClick={() => openDocument(contracts.find(contract => contract.id == building.proxyFrench_id).template_id)}
                                                        className="relative inline-flex w-0 flex-1 items-center justify-center rounded-br-lg border border-transparent py-4 text-sm font-medium text-gray-700 hover:text-gray-500"
                                                    >
                                                        <DocumentMagnifyingGlassIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                                        <span className="ml-3">Volmacht (FR)</span>
                                                    </a>
                                                </div>
                                            </div>

                                        </div>) : null}
                                        {building.type == "BAV" && building.proxyDutch_id ? (
                                        <div className="">
                                            <div className="-mt-px flex divide-x divide-gray-200 border-t">
                                                <div className="flex w-0 flex-1">
                                                    <a
                                                        onClick={() => openDocument(contracts.find(contract => contract.id == building.proxyDutch_id).template_id)}
                                                        className="relative inline-flex w-0 flex-1 items-center justify-center border border-transparent py-4 text-sm font-medium text-gray-700 hover:text-gray-500"
                                                    >
                                                        <DocumentMagnifyingGlassIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                                        <span className="ml-3">Volmacht</span>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>) : null}
                                        <div className="pt-4 pb-4 mt-auto">
                                            <h3 className="text-lg font-bold text-gray-900 capitalize">{building.name} <span className="font-normal text-gray-600 text-xs">({building.type})</span></h3>
                                            {building.building_metadata ? (
                                                <div className="text-xs text-gray-400 mt-1 px-2">
                                                    {Object.entries(JSON.parse(building.building_metadata)).map(([k, v]) => (
                                                        <p key={k}><span className="font-medium text-gray-500">{k}:</span> {v}</p>
                                                    ))}
                                                </div>
                                            ) : null}
                                            <button
                                                onClick={() => openEditModal(building)}
                                                className="inline-flex items-center text-xs text-indigo-600 hover:text-indigo-500 mt-2"
                                            >
                                                <PencilSquareIcon className="h-3 w-3 mr-1" />
                                                Metadata bewerken
                                            </button>
                                        </div>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>

            {/* MODAL */}
            <Transition.Root show={modalOpen} as={Fragment}>
                <Dialog as="div" className="relative z-10" onClose={setModalOpen}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                    </Transition.Child>

                    <div className="fixed inset-0 z-10 overflow-y-auto">
                        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                enterTo="opacity-100 translate-y-0 sm:scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            >
                                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
                                    <div>

                                        <div className="mt-1">
                                            <Dialog.Title as="h3" className="text-lg font-medium leading-6 text-gray-900">
                                                Gebouw toevoegen
                                            </Dialog.Title>
                                            <div className="mt-2">
                                                <p className="text-sm text-gray-500">
                                                    Vul onderstaande velden aan om een nieuw gebouw toe te voegen.
                                                </p>
                                            </div>
                                            <div>
                                                <form className="mt-6 grid grid-cols-1 gap-y-6">
                                                    <div className="">
                                                        <label htmlFor="" className="mb-1 block text-sm font-medium text-gray-700">
                                                            Afbeelding
                                                        </label>
                                                        {!image ?
                                                            <label
                                                                className="flex justify-center w-full h-32 px-4 transition bg-white border-2 border-gray-300 border-dashed rounded-md appearance-none cursor-pointer hover:border-gray-400 focus:outline-none">
                                                                <span className="flex items-center space-x-2 text-gray-400">
                                                                    <CloudArrowUpIcon className="w-6 h-6" />
                                                                    <span className="font-medium">
                                                                        Sleep je bestand hierheen of&nbsp;
                                                                        <span className="text-indigo-600">selecteer</span>.
                                                                    </span>
                                                                </span>
                                                                <input
                                                                    type="file"
                                                                    name="image"
                                                                    className="hidden"
                                                                    onChange={(event) => setImage(event.target.files[0])}
                                                                    accept="image/*"
                                                                    multiple={false}
                                                                />
                                                            </label>
                                                            :
                                                            <div className="justify-center px-4 pb-4 transition bg-white border-2 border-gray-300 border-dashed rounded-md appearance-none cursor-pointer hover:border-gray-400 focus:outline-none">
                                                                <img src={URL.createObjectURL(image)} className="" />
                                                                <a className="text-xs text-gray-400 underline" onClick={() => setImage()}>Verwijder geselecteerd bestand</a>
                                                            </div>
                                                        }

                                                        <label htmlFor="name" className="mt-5 block text-sm font-medium text-gray-700">
                                                            Naam
                                                        </label>
                                                        <div className="mt-1">
                                                            <input
                                                                type="text"
                                                                name="name"
                                                                id="name"
                                                                className="block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md"
                                                                onChange={e => (setName(e.target.value))}
                                                                value={name}
                                                            />
                                                        </div>

                                                        <label htmlFor="type" className="mt-5 block text-sm font-medium text-gray-700">
                                                            Type
                                                        </label>
                                                        <div className="mt-1">
                                                            <select
                                                                id="type"
                                                                name="type"
                                                                className="block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md"
                                                                onChange={e => {
                                                                    setType(e.target.value);
                                                                    if (e.target.value === "BAV") {
                                                                        setMetadataFields(prev => {
                                                                            const hasCompanyName = prev.some(f => f.key === "companyName");
                                                                            const hasCompanyNumber = prev.some(f => f.key === "companyNumber");
                                                                            let fields = [...prev];
                                                                            if (!hasCompanyName) fields.unshift({ key: "companyName", value: "" });
                                                                            if (!hasCompanyNumber) {
                                                                                const idx = fields.findIndex(f => f.key === "companyName");
                                                                                fields.splice(idx + 1, 0, { key: "companyNumber", value: "" });
                                                                            }
                                                                            return fields;
                                                                        });
                                                                    }
                                                                }}
                                                                value={type}
                                                                placeholder="Selecteer het type"
                                                            >
                                                                <option value="" disabled>Selecteer het type</option>
                                                                <option value="BV">BV</option>
                                                                <option value="BAV">BAV</option>
                                                                <option value="VME">VME</option>
                                                                <option value="IV">Infovergadering</option>
                                                            </select>
                                                        </div>

                                                        {type == "BAV" ?
                                                            <div>
                                                                <label htmlFor="volmacht" className="mb-1 mt-5 block text-sm font-medium text-gray-700">
                                                                    Volmacht
                                                                </label>
                                                                <select
                                                                    id="volmacht"
                                                                    name="volmacht"
                                                                    className="mt-1 block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                                                                    defaultValue="Selecteer een contract..."
                                                                    onChange={e => (setProxyDutch(e.target.value))}
                                                                >
                                                                    <option value="Selecteer een contract..." default disabled>Selecteer een contract...</option>
                                                                    {contracts.map((contract) => (
                                                                        <option value={contract.id}>{contract.name}</option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                            : null}

                                                        {type == "BV" || type == "VME" ?
                                                            <div>
                                                                <label htmlFor="onlineDutch" className="mb-1 mt-5 block text-sm font-medium text-gray-700">
                                                                    Volmacht (NL)
                                                                </label>
                                                                <select
                                                                    id="volmachtNL"
                                                                    name="volmachtNL"
                                                                    className="mt-1 block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                                                                    defaultValue="Selecteer een contract..."
                                                                    onChange={e => (setProxyDutch(e.target.value))}
                                                                >
                                                                    <option value="Selecteer een contract..." default disabled>Selecteer een contract...</option>
                                                                    {contracts.map((contract) => (
                                                                        <option value={contract.id}>{contract.name}</option>
                                                                    ))}
                                                                </select>

                                                                <label htmlFor="onlineDutch" className="mb-1 mt-5 block text-sm font-medium text-gray-700">
                                                                    Volmacht (FR)
                                                                </label>
                                                                <select
                                                                    id="volmachtFR"
                                                                    name="volmachtFR"
                                                                    className="mt-1 block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                                                                    defaultValue="Selecteer een contract..."
                                                                    onChange={e => (setProxyFrench(e.target.value))}
                                                                >
                                                                    <option value="Selecteer een contract..." default disabled>Selecteer een contract...</option>
                                                                    {contracts.map((contract) => (
                                                                        <option value={contract.id}>{contract.name}</option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                            : null}

                                                        {type == "VME" ?
                                                            <div>
                                                                <label htmlFor="onlineDutch" className="mb-1 mt-5 block text-sm font-medium text-gray-700">
                                                                    Contract online (NL)
                                                                </label>
                                                                <select
                                                                    id="volmachtOnlineNL"
                                                                    name="volmachtOnlineNL"
                                                                    className="mt-1 block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                                                                    defaultValue="Selecteer een contract..."
                                                                    onChange={e => (setOnlineDutch(e.target.value))}
                                                                >
                                                                    <option value="Selecteer een contract..." default disabled>Selecteer een contract...</option>
                                                                    {contracts.map((contract) => (
                                                                        <option value={contract.id}>{contract.name}</option>
                                                                    ))}
                                                                </select>

                                                                <label htmlFor="onlineDutch" className="mb-1 mt-5 block text-sm font-medium text-gray-700">
                                                                    Contract online (FR)
                                                                </label>
                                                                <select
                                                                    id="volmachtOnlineFR"
                                                                    name="volmachtOnlineFR"
                                                                    className="mt-1 block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                                                                    defaultValue="Selecteer een contract..."
                                                                    onChange={e => (setOnlineFrench(e.target.value))}
                                                                >
                                                                    <option value="Selecteer een contract..." default disabled>Selecteer een contract...</option>
                                                                    {contracts.map((contract) => (
                                                                        <option value={contract.id}>{contract.name}</option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                            : null}

                                                        <label className="mb-1 mt-5 block text-sm font-medium text-gray-700">
                                                            Metadata
                                                        </label>
                                                        <div className="space-y-2">
                                                            {metadataFields.map((field, index) => {
                                                                const isRequired = type === "BAV" && (field.key === "companyName" || field.key === "companyNumber");
                                                                return (
                                                                <div key={index} className="flex gap-2 items-center">
                                                                    <input
                                                                        type="text"
                                                                        placeholder="Veld"
                                                                        className={`block w-1/3 rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm ${isRequired ? "bg-gray-100" : ""}`}
                                                                        value={field.key}
                                                                        disabled={isRequired}
                                                                        onChange={e => {
                                                                            const updated = [...metadataFields];
                                                                            updated[index].key = e.target.value;
                                                                            setMetadataFields(updated);
                                                                        }}
                                                                    />
                                                                    <input
                                                                        type="text"
                                                                        placeholder="Waarde"
                                                                        className="block flex-1 rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                                                                        value={field.value}
                                                                        onChange={e => {
                                                                            const updated = [...metadataFields];
                                                                            updated[index].value = e.target.value;
                                                                            setMetadataFields(updated);
                                                                        }}
                                                                    />
                                                                    {!isRequired ?
                                                                        <button
                                                                            type="button"
                                                                            className="text-red-400 hover:text-red-600 text-sm"
                                                                            onClick={() => setMetadataFields(metadataFields.filter((_, i) => i !== index))}
                                                                        >
                                                                            x
                                                                        </button>
                                                                    : <span className="text-xs text-gray-400 w-3">*</span>}
                                                                </div>
                                                                );
                                                            })}
                                                            <button
                                                                type="button"
                                                                className="inline-flex items-center text-sm text-indigo-600 hover:text-indigo-500"
                                                                onClick={() => setMetadataFields([...metadataFields, { key: "", value: "" }])}
                                                            >
                                                                <PlusCircleIcon className="h-4 w-4 mr-1" />
                                                                Veld toevoegen
                                                            </button>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mt-12 sm:mt-12 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
                                        <button
                                            type="button"
                                            className="inline-flex w-full justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:col-start-2 sm:text-sm"
                                            onClick={() => createBuilding()}
                                        >
                                            Aanmaken
                                        </button>
                                        <button
                                            type="button"
                                            className="mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:col-start-1 sm:mt-0 sm:text-sm"
                                            onClick={() => closeModal()}
                                        >
                                            Annuleer
                                        </button>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>

            {/* EDIT METADATA MODAL */}
            <Transition.Root show={editModalOpen} as={Fragment}>
                <Dialog as="div" className="relative z-10" onClose={setEditModalOpen}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                    </Transition.Child>

                    <div className="fixed inset-0 z-10 overflow-y-auto">
                        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                enterTo="opacity-100 translate-y-0 sm:scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            >
                                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
                                    <div>
                                        <div className="mt-1">
                                            <Dialog.Title as="h3" className="text-lg font-medium leading-6 text-gray-900">
                                                Metadata bewerken
                                            </Dialog.Title>
                                            <div className="mt-4 space-y-2">
                                                {editMetadataFields.map((field, index) => {
                                                    const isRequired = editBuildingType === "BAV" && (field.key === "companyName" || field.key === "companyNumber");
                                                    return (
                                                    <div key={index} className="flex gap-2 items-center">
                                                        <input
                                                            type="text"
                                                            placeholder="Veld"
                                                            className={`block w-1/3 rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm ${isRequired ? "bg-gray-100" : ""}`}
                                                            value={field.key}
                                                            disabled={isRequired}
                                                            onChange={e => {
                                                                const updated = [...editMetadataFields];
                                                                updated[index].key = e.target.value;
                                                                setEditMetadataFields(updated);
                                                            }}
                                                        />
                                                        <input
                                                            type="text"
                                                            placeholder="Waarde"
                                                            className="block flex-1 rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                                                            value={field.value}
                                                            onChange={e => {
                                                                const updated = [...editMetadataFields];
                                                                updated[index].value = e.target.value;
                                                                setEditMetadataFields(updated);
                                                            }}
                                                        />
                                                        {!isRequired ?
                                                            <button
                                                                type="button"
                                                                className="text-red-400 hover:text-red-600 text-sm"
                                                                onClick={() => setEditMetadataFields(editMetadataFields.filter((_, i) => i !== index))}
                                                            >
                                                                x
                                                            </button>
                                                        : <span className="text-xs text-gray-400 w-3">*</span>}
                                                    </div>
                                                    );
                                                })}
                                                <button
                                                    type="button"
                                                    className="inline-flex items-center text-sm text-indigo-600 hover:text-indigo-500"
                                                    onClick={() => setEditMetadataFields([...editMetadataFields, { key: "", value: "" }])}
                                                >
                                                    <PlusCircleIcon className="h-4 w-4 mr-1" />
                                                    Veld toevoegen
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mt-8 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
                                        <button
                                            type="button"
                                            className="inline-flex w-full justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:col-start-2 sm:text-sm"
                                            onClick={() => saveMetadata()}
                                        >
                                            Opslaan
                                        </button>
                                        <button
                                            type="button"
                                            className="mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:col-start-1 sm:mt-0 sm:text-sm"
                                            onClick={() => setEditModalOpen(false)}
                                        >
                                            Annuleer
                                        </button>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>
        </main>
    )
}